import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/styles";
import { useTranslation } from "react-i18next";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import useTheme from "@material-ui/styles/useTheme";

const useStyles = makeStyles((theme) => ({
    autocompleteWrap: {
        margin: theme.spacing(4, 0),
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.75rem",
        },
    },
    textFieldRoot: {
        "& > label": {
            [theme.breakpoints.down("sm")]: {
                fontSize: "0.75rem",
            },
        },
    },
}));

const SearchRSISYSTEMY = ({ dataSet, onSelect, onInputChange }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    // eslint-disable-next-line
    const theme = useTheme();

    const options = dataSet.map((option) => {
        const firstLetter = option.nazwa_systemu[0].toUpperCase();
        return {
            firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
            ...option,
        };
    });

    const handleChange = (event, value, reason) => {
        // console.log('handleChange: ', value)
        onInputChange(value);
        value && onSelect({ itemId: value.id_systemu, firstLetter: value.firstLetter });
    };

    const handleInputChange = (newInputValue) => {
        // console.log('handleInputChange in autocomplete: ', newInputValue)
        onInputChange(newInputValue);
    };

    return (
        <Autocomplete
            id="grouped-SearchRSISYSTEMY"
            freeSolo
            open={false}
            options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
            groupBy={(option) => option.firstLetter}
            getOptionLabel={(option) => option.nazwa_systemu}
            getOptionSelected={(option) => option.nazwa_systemu}
            className={classes.autocompleteWrap}
            fullWidth
            onChange={handleChange}
            onInputChange={(event, newInputValue) => {
                handleInputChange(newInputValue);
            }}
            renderInput={(params) => (
                <TextField
                    color="primary"
                    {...params}
                    label={t("common.searchRSISYSTEMY")}
                    variant="outlined"
                    size={"small"}
                    classes={{ root: classes.textFieldRoot }}
                />
            )}
            renderOption={(option, { inputValue }) => {
                const matches = match(option.nazwa_systemu, inputValue);
                const parts = parse(option.nazwa_systemu, matches);

                return (
                    <div>
                        {parts.map((part, index) => (
                            <span
                                key={index}
                                style={{
                                    // fontWeight: part.highlight ? 700 : 400,
                                    backgroundColor: part.highlight ? "inherit" : "inherit", //theme.palette.primary.main : 'inherit',
                                    color: part.highlight ? "inherit" : "inherit", //theme.palette.primary.contrastText : 'inherit'
                                }}
                            >
                                {part.text}
                            </span>
                        ))}
                    </div>
                );
            }}
        />
    );
};

export default SearchRSISYSTEMY;
